<article class="box_default box_white">
  <header>
    <h3>ADD NEW WORKFLOW</h3>
    <!-- <div class="instructions">
        <a (click)="showInstructions = !showInstructions" class="trigger" [ngClass]="{'opened' : showInstructions}"><em>How does this work?</em></a>
        <ol *ngIf="showInstructions">
          <li><strong>TO GIVE</strong> your workflow <strong>A NAME</strong>, start typing on the <strong>NAME</strong> box. Click <strong>SAVE</strong> to store the name. Click <strong>CANCEL</strong> to stop the process.</li>
          <li>To <strong>BUILD YOUR NEW WORKFLOW</strong>, click on the name from the list, navigate below, and start creating new workflow stages and transitions.</li>
        </ol>
      </div>
      -->
  </header>
  <div class="box_main">
    <form [formGroup]="form">
      <!-- <span class="txt_error" *ngIf="errorAddStatus">{{textError}}</span> -->
      <div class="box_item">
        <label class="box-label">NAME</label>
          <input type="text" placeholder="Write the name for your new workflow" formControlName="name"/>
      </div>
      <!-- TODO color selector -->
      <div class="box_fieldset">
        <core-helpers-forms-button-white [text]="'Save'" [disabled]="form.invalid" (click)= "add()"></core-helpers-forms-button-white>
        <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel($event)"></core-helpers-forms-button>
      </div>
    </form>
  </div>
</article>
